/**
 * Alert System
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Application } from '../model/application';
import { Customer } from '../model/customer';
import { EarthquakeResponse } from '../model/earthquakeResponse';
import { EarthquakeSource } from '../model/earthquakeSource';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EarthquakeService {

    protected basePath = 'http://195.34.120.2:{port}/{basePath}';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * get earthquake data
     * get earthquake data
     * @param app_id 
     * @param source 
     * @param cust_id 
     * @param offset 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public earthquake(app_id: Application, source: EarthquakeSource, cust_id?: Customer, offset?: number, observe?: 'body', reportProgress?: boolean): Observable<EarthquakeResponse>;
    public earthquake(app_id: Application, source: EarthquakeSource, cust_id?: Customer, offset?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EarthquakeResponse>>;
    public earthquake(app_id: Application, source: EarthquakeSource, cust_id?: Customer, offset?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EarthquakeResponse>>;
    public earthquake(app_id: Application, source: EarthquakeSource, cust_id?: Customer, offset?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (app_id === null || app_id === undefined) {
            throw new Error('Required parameter app_id was null or undefined when calling earthquake.');
        }

        if (source === null || source === undefined) {
            throw new Error('Required parameter source was null or undefined when calling earthquake.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }

        let headers = this.defaultHeaders;
        if (app_id !== undefined && app_id !== null) {
            headers = headers.set('app-id', String(app_id));
        }
        if (cust_id !== undefined && cust_id !== null) {
            headers = headers.set('cust-id', String(cust_id));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<EarthquakeResponse>('get',`${this.basePath}/seismicportal/${encodeURIComponent(String(source))}/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
